import Vue from 'vue'
import VueRouter from 'vue-router'
import Startseite from '../views/Startseite.vue'
import Karriere from '../views/Karriere.vue'
import Kontakt from '../views/Kontakt.vue'
import PlanungEntwicklung from '../views/PlanungEntwicklung.vue'
import Werkzeugbau from '../views/Werkzeugbau.vue'
import Konstruktion from '../views/Konstruktion.vue'
import Anwendungstechnik from '../views/Anwendungstechnik.vue'
import Endprodukt from '../views/Endprodukt.vue'
import UeberUns from '../views/UeberUns.vue'
import Lehre from '../views/Lehre.vue'
import Impressum from '../views/Impressum.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Startseite',
    component: Startseite
  },
  {
    path: '/planung',
    name: 'Planung',
    component: PlanungEntwicklung
  },
  {
    path: '/konstruktion',
    name: 'Konstruktion',
    component: Konstruktion
  },
  {
    path: '/werkzeugbau',
    name: 'Werkzeugbau',
    component: Werkzeugbau
  },
  {
    path: '/anwendungstechnik',
    name: 'Anwendungstechnik',
    component: Anwendungstechnik
  },
  {
    path: '/endprodukt',
    name: 'Endprodukt',
    component: Endprodukt
  }/*,
  {
    path: '/ueberUns',
    name: 'Über uns',
    component: UeberUns
  }*/,
  {
    path: '/lehre',
    name: 'Lehre',
    component: Lehre
  },
  {
    path: '/karriere',
    name: 'Karriere',
    component: Karriere
  },
  {
    path: '/kontakt',
    name: 'Kontakt',
    component: Kontakt
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
  
})

export default router
